import { Locale } from "@/lib/i18n";
import { Tool } from "@/types";

const instructions = {
  en: {
    "pdf-to-jpg": [
      "Upload your PDF file",
      "Wait for conversion to complete",
      "Preview the converted images",
      "Download individual pages or all at once",
    ],
    "pdf-to-png": [
      "Upload your PDF file",
      "Wait for conversion to complete",
      "Preview the converted images",
      "Download individual pages or all at once",
    ],
    "merge-pdf": [
      "Select multiple PDF files to merge",
      "Reorder files using the move controls if needed",
      'Click the "Merge PDFs" button',
      "Download the combined PDF file",
    ],
    "split-pdf": [
      "Upload your PDF file",
      "Choose the split option for all pages or a range",
      "Select the page range if needed",
      "Download the split PDF files",
    ],
    "compress-pdf": [
      "Upload your PDF file",
      'Click the "Compress PDF" button',
      "Review the compression result and file size",
      "Download the compressed file",
    ],
    "jpg-to-pdf": [
      "Select one or more images",
      "Reorder images if needed",
      'Click the "Convert to PDF" button',
      "Download your PDF file",
    ],
    "rotate-pdf": [
      "Upload your PDF file",
      "Choose the rotation angle",
      'Click the "Rotate All Pages" button',
      "Download the rotated PDF",
    ],
    "add-watermark": [
      "Upload your PDF file",
      "Enter the watermark text",
      "Adjust the font size and opacity",
      "Download the watermarked PDF",
    ],
    "pdf-to-word": [
      "Upload your PDF file",
      'Click "Convert to Word"',
      "Wait for text extraction to finish",
      "Download the DOCX file",
    ],
    "word-to-pdf": [
      "Select your Word document",
      'Click "Convert to PDF"',
      "Wait for the conversion to finish",
      "Download the PDF file",
    ],
    "pdf-to-excel": [
      "Upload your PDF file",
      "The text will be extracted into spreadsheet rows",
      'Click "Convert to Excel"',
      "Download the XLSX file",
    ],
    "excel-to-pdf": [
      "Select your Excel file",
      "Sheets will be converted into printable tables",
      'Click "Convert to PDF"',
      "Download the PDF file",
    ],
    "pdf-to-powerpoint": [
      "Upload your PDF file",
      "Each page will become a slide",
      'Click "Convert to PowerPoint"',
      "Download the PPTX file",
    ],
    "edit-pdf": [
      "Upload your PDF file",
      "Choose a tool such as text, shapes, or draw",
      "Click on the canvas to add annotations",
      "Navigate pages and save the edited PDF",
    ],
    "sign-pdf": [
      "Upload your PDF file",
      "Draw your signature on the canvas",
      "Place the signature on the document",
      "Download the signed PDF",
    ],
    "image-resizer": [
      "Upload your image",
      "Enter the new width and height",
      "Lock the aspect ratio if needed",
      "Download the resized image",
    ],
    "image-compressor": [
      "Upload your image",
      "Adjust the quality level",
      "Preview the before and after result",
      "Download the compressed image",
    ],
    "image-converter": [
      "Choose the conversion type",
      "Upload your image",
      "Preview the image result",
      "Download it in the new format",
    ],
    "jpg-to-png": [
      "Choose the conversion type",
      "Upload your image",
      "Preview the image result",
      "Download it in the new format",
    ],
    "png-to-jpg": [
      "Choose the conversion type",
      "Upload your image",
      "Preview the image result",
      "Download it in the new format",
    ],
    "webp-to-jpg": [
      "Choose the conversion type",
      "Upload your image",
      "Preview the image result",
      "Download it in the new format",
    ],
    "image-cropper": [
      "Upload your image",
      "Pick the aspect ratio preset",
      "Adjust the crop area position and size",
      "Download the cropped image",
    ],
    "remove-background": [
      "Upload your image",
      'Click the "Remove Background" button',
      "Preview the transparent result",
      "Download the PNG output",
    ],
    "word-counter": [
      "Paste or type your text",
      "Watch the statistics update in real time",
      "Review word, character, and sentence counts",
      "Clear the text to start over",
    ],
    "case-converter": [
      "Enter your text",
      "Choose the case style you want",
      'Click the "Convert Text" button',
      "Copy the converted result",
    ],
    "lorem-ipsum": [
      "Set the number of paragraphs",
      "Set the words per paragraph",
      'Click the "Generate Lorem Ipsum" button',
      "Copy the generated text",
    ],
    "json-formatter": [
      "Paste your JSON code",
      "Choose format or minify mode",
      "Set the indent size if formatting",
      "Copy the formatted output",
    ],
    "diff-checker": [
      "Paste the original text in the left panel",
      "Paste the changed text in the right panel",
      'Click the "Compare Texts" button',
      "Review the highlighted differences",
    ],
    "markdown-editor": [
      "Write markdown in the editor",
      "See the live preview on the side",
      "Use markdown syntax for formatting",
      "Copy the markdown when you are done",
    ],
    "qr-generator": [
      "Enter text or a URL",
      "Adjust the QR code size",
      "Choose the error correction level",
      "Download the QR code as PNG",
    ],
    "password-generator": [
      "Set the password length",
      "Choose the character types to include",
      'Click the "Generate Password" button',
      "Copy the secure password",
    ],
    "uuid-generator": [
      "Choose the UUID version",
      "Set how many UUIDs to generate",
      'Click the "Generate UUIDs" button',
      "Copy one UUID or the whole list",
    ],
  },
  id: {
    "pdf-to-jpg": [
      "Upload file PDF kamu",
      "Tunggu sampai konversi selesai",
      "Lihat preview gambar hasil konversi",
      "Unduh per halaman atau semuanya sekaligus",
    ],
    "pdf-to-png": [
      "Upload file PDF kamu",
      "Tunggu sampai konversi selesai",
      "Lihat preview gambar hasil konversi",
      "Unduh per halaman atau semuanya sekaligus",
    ],
    "merge-pdf": [
      "Pilih beberapa file PDF untuk digabungkan",
      "Atur ulang urutan file jika perlu",
      'Klik tombol "Merge PDFs"',
      "Unduh hasil PDF gabungan",
    ],
    "split-pdf": [
      "Upload file PDF kamu",
      "Pilih opsi pemisahan semua halaman atau rentang tertentu",
      "Tentukan rentang halaman jika diperlukan",
      "Unduh hasil file PDF yang sudah dipisah",
    ],
    "compress-pdf": [
      "Upload file PDF kamu",
      'Klik tombol "Compress PDF"',
      "Tinjau hasil kompresi dan ukuran file",
      "Unduh file yang sudah dikompres",
    ],
    "jpg-to-pdf": [
      "Pilih satu atau lebih gambar",
      "Atur ulang urutan gambar jika perlu",
      'Klik tombol "Convert to PDF"',
      "Unduh hasil file PDF",
    ],
    "rotate-pdf": [
      "Upload file PDF kamu",
      "Pilih sudut rotasi",
      'Klik tombol "Rotate All Pages"',
      "Unduh hasil PDF yang sudah diputar",
    ],
    "add-watermark": [
      "Upload file PDF kamu",
      "Masukkan teks watermark",
      "Atur ukuran font dan opasitas",
      "Unduh PDF yang sudah diberi watermark",
    ],
    "pdf-to-word": [
      "Upload file PDF kamu",
      'Klik "Convert to Word"',
      "Tunggu proses ekstraksi teks selesai",
      "Unduh file DOCX",
    ],
    "word-to-pdf": [
      "Pilih dokumen Word kamu",
      'Klik "Convert to PDF"',
      "Tunggu proses konversi selesai",
      "Unduh file PDF",
    ],
    "pdf-to-excel": [
      "Upload file PDF kamu",
      "Teks akan diekstrak ke format spreadsheet",
      'Klik "Convert to Excel"',
      "Unduh file XLSX",
    ],
    "excel-to-pdf": [
      "Pilih file Excel kamu",
      "Setiap sheet akan diubah menjadi tabel siap cetak",
      'Klik "Convert to PDF"',
      "Unduh file PDF",
    ],
    "pdf-to-powerpoint": [
      "Upload file PDF kamu",
      "Setiap halaman akan menjadi slide",
      'Klik "Convert to PowerPoint"',
      "Unduh file PPTX",
    ],
    "edit-pdf": [
      "Upload file PDF kamu",
      "Pilih tool seperti teks, bentuk, atau gambar bebas",
      "Klik pada kanvas untuk menambahkan anotasi",
      "Pindah halaman lalu simpan PDF yang sudah diedit",
    ],
    "sign-pdf": [
      "Upload file PDF kamu",
      "Gambar tanda tangan di kanvas",
      "Tempatkan tanda tangan di dokumen",
      "Unduh PDF yang sudah ditandatangani",
    ],
    "image-resizer": [
      "Upload gambar kamu",
      "Masukkan lebar dan tinggi baru",
      "Kunci rasio aspek jika diperlukan",
      "Unduh gambar yang sudah di-resize",
    ],
    "image-compressor": [
      "Upload gambar kamu",
      "Atur tingkat kualitas",
      "Lihat preview sebelum dan sesudah",
      "Unduh gambar yang sudah dikompres",
    ],
    "image-converter": [
      "Pilih jenis konversi",
      "Upload gambar kamu",
      "Lihat preview hasil gambar",
      "Unduh dalam format baru",
    ],
    "jpg-to-png": [
      "Pilih jenis konversi",
      "Upload gambar kamu",
      "Lihat preview hasil gambar",
      "Unduh dalam format baru",
    ],
    "png-to-jpg": [
      "Pilih jenis konversi",
      "Upload gambar kamu",
      "Lihat preview hasil gambar",
      "Unduh dalam format baru",
    ],
    "webp-to-jpg": [
      "Pilih jenis konversi",
      "Upload gambar kamu",
      "Lihat preview hasil gambar",
      "Unduh dalam format baru",
    ],
    "image-cropper": [
      "Upload gambar kamu",
      "Pilih preset rasio aspek",
      "Atur posisi dan ukuran area crop",
      "Unduh gambar yang sudah di-crop",
    ],
    "remove-background": [
      "Upload gambar kamu",
      'Klik tombol "Remove Background"',
      "Lihat preview hasil transparan",
      "Unduh output PNG",
    ],
    "word-counter": [
      "Tempel atau ketik teks kamu",
      "Lihat statistik yang diperbarui secara real-time",
      "Tinjau jumlah kata, karakter, dan kalimat",
      "Hapus teks untuk memulai lagi",
    ],
    "case-converter": [
      "Masukkan teks kamu",
      "Pilih gaya huruf yang diinginkan",
      'Klik tombol "Convert Text"',
      "Salin hasil konversi",
    ],
    "lorem-ipsum": [
      "Tentukan jumlah paragraf",
      "Tentukan jumlah kata per paragraf",
      'Klik tombol "Generate Lorem Ipsum"',
      "Salin teks yang dihasilkan",
    ],
    "json-formatter": [
      "Tempel kode JSON kamu",
      "Pilih mode format atau minify",
      "Atur ukuran indent jika ingin memformat",
      "Salin hasil output",
    ],
    "diff-checker": [
      "Tempel teks asli di panel kiri",
      "Tempel teks perubahan di panel kanan",
      'Klik tombol "Compare Texts"',
      "Tinjau perbedaan yang disorot",
    ],
    "markdown-editor": [
      "Tulis markdown di editor",
      "Lihat preview langsung di samping",
      "Gunakan sintaks markdown untuk formatting",
      "Salin markdown setelah selesai",
    ],
    "qr-generator": [
      "Masukkan teks atau URL",
      "Atur ukuran QR code",
      "Pilih tingkat error correction",
      "Unduh QR code sebagai PNG",
    ],
    "password-generator": [
      "Tentukan panjang password",
      "Pilih jenis karakter yang ingin disertakan",
      'Klik tombol "Generate Password"',
      "Salin password yang aman",
    ],
    "uuid-generator": [
      "Pilih versi UUID",
      "Tentukan jumlah UUID yang ingin dibuat",
      'Klik tombol "Generate UUIDs"',
      "Salin satu UUID atau seluruh daftar",
    ],
  },
} as const satisfies Partial<Record<Locale, Record<string, string[]>>>;

export const getToolInstructions = (tool: Tool, locale: Locale): string[] => {
  const localizedInstructions =
    (instructions as Partial<Record<Locale, Record<string, string[]>>>)[locale] ?? {};
  const englishInstructions = instructions.en as Record<string, string[]>;

  return localizedInstructions[tool.id] ?? englishInstructions[tool.id] ?? [];
};
